export const WORD_FETCHED = 'WORD_FETCHED';
export const ATTEMPT_MADE = 'ATTEMPT_MADE';
export const TIME_ENDED = 'TIME_ENDED';
export const OPPONENT_ATTEMPT = 'OPPONENT_ATTEMPT';
export const ROOM_CREATED = 'ROOM_CREATED';
export const ROOM_JOINED = 'ROOM_JOINED';
export const GAME_ENDED = 'GAME_ENDED';